import React, { useState, useEffect } from 'react';
import { listenToPromos, addPromo, updatePromo, deletePromo } from '../services/firebase';
import toast from 'react-hot-toast';

const emptyForm = { code: '', discountType: 'fixed', discountValue: '', active: true, expiry: '' };

export default function Promos() {
  const [promos, setPromos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => listenToPromos(setPromos), []);

  const openNew = () => {
    setForm(emptyForm);
    setEditingId(null);
    setShowForm(true);
  };

  const openEdit = (p) => {
    setForm({
      code: p.code || '',
      discountType: p.discountType || 'fixed',
      discountValue: p.discountValue ?? '',
      active: p.active !== false,
      expiry: p.expiry?.toDate ? p.expiry.toDate().toISOString().slice(0, 10) : (p.expiry || ''),
    });
    setEditingId(p.id);
    setShowForm(true);
  };

  const handleSave = async () => {
    if (!form.code || !form.discountValue) { toast.error('Code and discount value required'); return; }
    const payload = {
      code: form.code.trim().toUpperCase(),
      discountType: form.discountType,
      discountValue: Number(form.discountValue),
      active: form.active,
      expiry: form.expiry ? new Date(form.expiry) : null,
    };
    if (editingId) {
      await updatePromo(editingId, payload);
      toast.success('Promo updated');
    } else {
      await addPromo(payload);
      toast.success('Promo created');
    }
    setShowForm(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this promo?')) return;
    await deletePromo(id);
    toast.success('Deleted');
  };

  const fmtExpiry = (exp) => {
    if (!exp) return '—';
    if (exp.toDate) return exp.toDate().toLocaleDateString('en-IN');
    return String(exp);
  };

  return (
    <div className="page-body">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Promos</div>
          <div style={{ fontSize: 13, color: 'var(--text2)' }}>{promos.length} promo codes</div>
        </div>
        <button type="button" className="btn btn-green" onClick={openNew}>+ New promo</button>
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr><th>CODE</th><th>TYPE</th><th>VALUE</th><th>ACTIVE</th><th>EXPIRY</th><th>ACTIONS</th></tr>
          </thead>
          <tbody>
            {promos.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text2)', padding: 32 }}>No promos yet</td></tr>
            ) : promos.map((p) => (
              <tr key={p.id}>
                <td style={{ fontFamily: 'JetBrains Mono', fontWeight: 700 }}>{p.code}</td>
                <td>{p.discountType}</td>
                <td style={{ fontFamily: 'JetBrains Mono', color: 'var(--green)' }}>
                  {p.discountType === 'percent' ? `${p.discountValue}%` : `₹${p.discountValue}`}
                </td>
                <td><span className={`badge ${p.active ? 'badge-green' : 'badge-gray'}`}>{p.active ? 'Active' : 'Off'}</span></td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>{fmtExpiry(p.expiry)}</td>
                <td>
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => openEdit(p)}>Edit</button>
                  <button type="button" className="btn btn-ghost btn-sm" style={{ color: 'var(--red)' }} onClick={() => handleDelete(p.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setShowForm(false)}>
          <div className="card" style={{ maxWidth: 440, width: '100%', padding: 24 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{editingId ? 'Edit promo' : 'New promo'}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <input placeholder="Code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
              <select value={form.discountType} onChange={(e) => setForm({ ...form, discountType: e.target.value })}>
                <option value="fixed">Fixed (₹)</option>
                <option value="percent">Percent (%)</option>
              </select>
              <input type="number" placeholder="Discount value" value={form.discountValue} onChange={(e) => setForm({ ...form, discountValue: e.target.value })} />
              <input type="date" value={form.expiry} onChange={(e) => setForm({ ...form, expiry: e.target.value })} />
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                <input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} />
                Active
              </label>
              <button type="button" className="btn btn-green" onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
